import request from '../utils/request'

// 获取销售方案
export function getSalePackageList(params = { pageNum: 1, pageSize: 10 }) {
  return request({
    url: '/sale/salePackage/list',
    method: 'get',
    params
  })
}


/**
 * 新增预约
 */
export function addReservation(data) {
  return request({
    url: '/mall/reservation/add',
    method: 'post',
    data
  })
}

/**
 * 新增订单
 */
export function createOrder(data) {
  return request({
    url: '/sale/saleOrder/add',
    method: 'post',
    data
  })
}

/**
 * 生成支付链接
 */
export function createPay(params) {
  return request({
    url: '/sale/saleOrder/pay/createPay',
    method: 'get',
    params
  })
}

/**
 * 订单详情
 */
export function getSaleOrder(id) {
  return request({
    url: '/sale/saleOrder' + '/' + id,
    method: 'get',
  })
}

/**
 * 客服联系
 */
export function getCustomerManageList() {
  return request({
    url: '/customerManage/listByTenantId',
    method: 'get',
    params: {
      tenantId: '000000'
    }
  })
}

/**
 * 编辑订单
 */
export function cancelSaleOrder(id) {
  return request({
    url: '/sale/saleOrder/edit',
    method: 'post',
    data: {
      id,
      state : 5
    }
  })
}



